
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        showLoadingText: {
            type: Boolean,
            required: false
        },
        loadingText: {
            type: String,
            required: false
        },
        showLBackDrop: {
            type: Boolean,
            required: false
        }
    },
    data(props) {
        return {
            loadingTextContainer: props.showLoadingText || false,
            loadingMessage: props.loadingText || 'Loading...'
        };
    },
    methods: {}
});
